import { useContext } from 'react';

import { ServiceContext } from '../../../context/ServiceContext';
import type { CanadaService } from '../types';

interface ServiceContextValue {
  service?: CanadaService;
  isServiceLoading?: boolean;
}

// ServiceContext comes from untyped JS (createContext(null)); this hook types the
// boundary for the Canadian slice.
export default function useServiceContext(): ServiceContextValue {
  const value: ServiceContextValue | null = useContext(ServiceContext);
  return value ?? {};
}
